import { TableRow as BaseTableRow } from "@knowt/editor/extensions/table";

export const TableRow = BaseTableRow.extend({
    allowGapCursor: false,
    content: "(tableCell | tableHeader)*",
});

export default TableRow;
